import { BordBadge, BordTextButton } from 'bord-design-system';
import { bordColorTheme } from '../../../../../../styles/styles.constants';
import { getCategoryName } from '../../../../../../utils/namingConventionsManagement';
import { IQuoteItemDetailsForQuoteManagement } from '../../../../../../types/quoteEditor.types';
import { PRODUCT_CATEGORY } from '../../../../../../types/category';
import './DeviceCard.scss';

interface IDeviceCard {
  item: IQuoteItemDetailsForQuoteManagement;
  onEditClick?: () => void;
}

/**
 * Muestra el nombre y SKU de la herramienta solicitada, con un badge si el producto
 * es genérico y un botón de edición hacia el catálogo si tiene quoteItemId.
 */
const DeviceCard = ({ item, onEditClick }: IDeviceCard) => {
  const { productName, isGenericProduct, categoryName, quoteItemId, uid } = item;
  return (
    <div className="deviceCard">
      <div className="toolNameRow">
        <span className="toolName">{productName ?? getCategoryName(categoryName as PRODUCT_CATEGORY)}</span>
        {isGenericProduct && (
          <BordBadge className="genericBadge" label="Personalizado" variant="gradient" size="small" />
        )}
      </div>
      {quoteItemId && onEditClick && (
        <div className="skuRow">
          <span className="skuText">SKU: {uid}</span>
          <BordTextButton
            text=""
            onClick={onEditClick}
            rightIconProps={{
              variant: 'externalLink',
              standardSize: 12,
              stroke: bordColorTheme.cyan[400]
            }}
          />
        </div>
      )}
    </div>
  );
};

export default DeviceCard;
